import { render } from "./WallpaperGrid.vue?vue&type=template&id=269ffeb2&scoped=true"
import script from "./WallpaperGrid.vue?vue&type=script&lang=js"
export * from "./WallpaperGrid.vue?vue&type=script&lang=js"

import "./WallpaperGrid.vue?vue&type=style&index=0&id=269ffeb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-269ffeb2"]])

export default __exports__